var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShadowMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 295,
    viewBox: "0 0 325 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5236 -3.32139e-05L310 -1.60466e-06C318.284 -7.18429e-07 325 6.71573 325 15L325 148.988C292.548 160.413 254.365 167 213.5 167C95.5872 167 5.86718e-06 112.155 1.31047e-05 44.5C1.4784e-05 28.8019 5.14629 13.7936 14.5236 -3.32139e-05Z",
    fill: "#0008C3",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.678 -1.26578e-05L310 -1.60466e-06C318.284 -7.18431e-07 325 6.71573 325 15L325 294.873C322.524 294.957 320.037 295 317.537 295C214.013 295 130.089 221.886 130.089 131.696C130.089 77.6424 160.235 29.7224 206.678 -1.26578e-05Z",
    fill: "#0008C3",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShadowMobile);
export default __webpack_public_path__ + "static/media/bg-shadow-mobile.abd464b0b14b39f725f61da40a926b06.svg";
export { ForwardRef as ReactComponent };